import { FEATURE_CATALOGUE, getFeatureDefinition, } from './catalogue.js';
export const FEATURE_AVAILABILITY_REASONS = [
    'AVAILABLE',
    'SYSTEM_CORE',
    'DISABLED_BY_TENANT',
    'PLATFORM_UNAVAILABLE',
    'PLAN_UNAVAILABLE',
    'CONFIGURATION_MISSING',
    'DEPENDENCY_UNAVAILABLE',
];
function configurationPresent(requirement, configured) {
    return requirement.split('|').some((alternative) => configured.has(alternative));
}
/**
 * Resolves effective states deterministically. Dependencies are evaluated
 * recursively, so result correctness never depends on catalogue ordering.
 */
export function evaluateFeatureAvailability(preferences, context) {
    const preferenceByKey = new Map(preferences.map(({ key, desiredEnabled }) => [key, desiredEnabled]));
    const resolved = new Map();
    const resolve = (definition) => {
        const cached = resolved.get(definition.key);
        if (cached !== undefined)
            return cached;
        const desiredEnabled = definition.systemCore
            ? true
            : (preferenceByKey.get(definition.key) ?? definition.defaultEnabled);
        let state;
        if (definition.systemCore) {
            state = {
                key: definition.key,
                desiredEnabled: true,
                effectiveEnabled: true,
                reason: 'SYSTEM_CORE',
                blockingDependencies: [],
                missingConfiguration: [],
            };
        }
        else if (!definition.platform.available ||
            (context.platformAvailableKeys !== undefined &&
                !context.platformAvailableKeys.has(definition.key))) {
            state = {
                key: definition.key,
                desiredEnabled,
                effectiveEnabled: false,
                reason: 'PLATFORM_UNAVAILABLE',
                blockingDependencies: [],
                missingConfiguration: [],
            };
        }
        else if (context.entitledKeys !== undefined && !context.entitledKeys.has(definition.key)) {
            state = {
                key: definition.key,
                desiredEnabled,
                effectiveEnabled: false,
                reason: 'PLAN_UNAVAILABLE',
                blockingDependencies: [],
                missingConfiguration: [],
            };
        }
        else if (!desiredEnabled) {
            state = {
                key: definition.key,
                desiredEnabled: false,
                effectiveEnabled: false,
                reason: 'DISABLED_BY_TENANT',
                blockingDependencies: [],
                missingConfiguration: [],
            };
        }
        else {
            const missingConfiguration = definition.requiredConfiguration.filter((requirement) => !configurationPresent(requirement, context.configuredKeys));
            const blockingDependencies = definition.dependencies.filter((dependency) => !resolve(getFeatureDefinition(dependency)).effectiveEnabled);
            if (missingConfiguration.length > 0) {
                state = {
                    key: definition.key,
                    desiredEnabled: true,
                    effectiveEnabled: false,
                    reason: 'CONFIGURATION_MISSING',
                    blockingDependencies,
                    missingConfiguration,
                };
            }
            else if (blockingDependencies.length > 0) {
                state = {
                    key: definition.key,
                    desiredEnabled: true,
                    effectiveEnabled: false,
                    reason: 'DEPENDENCY_UNAVAILABLE',
                    blockingDependencies,
                    missingConfiguration: [],
                };
            }
            else {
                state = {
                    key: definition.key,
                    desiredEnabled: true,
                    effectiveEnabled: true,
                    reason: 'AVAILABLE',
                    blockingDependencies: [],
                    missingConfiguration: [],
                };
            }
        }
        const frozen = Object.freeze({
            ...state,
            blockingDependencies: Object.freeze([...state.blockingDependencies]),
            missingConfiguration: Object.freeze([...state.missingConfiguration]),
        });
        resolved.set(definition.key, frozen);
        return frozen;
    };
    return Object.freeze(FEATURE_CATALOGUE.map(resolve));
}
//# sourceMappingURL=availability.js.map